import { render, staticRenderFns } from "./TacticsView.vue?vue&type=template&id=71e32080&"
import script from "./TacticsView.vue?vue&type=script&lang=js&"
export * from "./TacticsView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports